import React, { Component } from 'react'
import Header from './multi/Header'
import Main from './Main'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header/>
        <Main/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js